import { gql } from '@apollo/client';

// Get all teams
export const GET_TEAMS = gql`
  query GetTeams {
    teams {
      id
      name
      description
      color
      isActive
      isContractor
      department
      createdAt
      updatedAt
      memberCount
      memberIds
      members {
        id
        firstName
        lastName
        email
        role
        isActive
      }
      userTeams {
        id
        userId
        teamId
        isPrimary
        createdAt
        user {
          id
          firstName
          lastName
          email
          role
          isActive
        }
        team {
          id
          name
          color
        }
      }
    }
  }
`;

// Get active teams only
export const GET_ACTIVE_TEAMS = gql`
  query GetActiveTeams($department: TeamDepartment) {
    activeTeams(department: $department) {
      id
      name
      description
      color
      isActive
      isContractor
      department
      createdAt
      updatedAt
      memberCount
      memberIds
    }
  }
`;

// Get single team
export const GET_TEAM = gql`
  query GetTeam($id: Int!) {
    team(id: $id) {
      id
      name
      description
      color
      isActive
      isContractor
      department
      createdAt
      updatedAt
      memberCount
      memberIds
      members {
        id
        firstName
        lastName
        email
        role
        phoneNumber
        areas
        isActive
      }
      userTeams {
        id
        userId
        teamId
        isPrimary
        createdAt
        user {
          id
          firstName
          lastName
          email
          role
          isActive
          phoneNumber
        }
        team {
          id
          name
          color
        }
      }
    }
  }
`;

// Get team members with multi-team support
export const GET_TEAM_MEMBERS = gql`
  query GetTeamMembers($teamId: Int!) {
    teamMembers(teamId: $teamId) {
      id
      userId
      teamId
      isPrimary
      createdAt
      user {
        id
        firstName
        lastName
        email
        role
        isActive
        phoneNumber
      }
      team {
        id
        name
        color
      }
    }
  }
`;

// Get user teams
export const GET_USER_TEAMS = gql`
  query GetUserTeams($userId: Int!) {
    userTeams(userId: $userId) {
      id
      userId
      teamId
      isPrimary
      createdAt
      user {
        id
        firstName
        lastName
        email
        role
        isActive
      }
      team {
        id
        name
        color
      }
    }
  }
`;

// Create team mutation
export const CREATE_TEAM = gql`
  mutation CreateTeam($createTeamInput: CreateTeamInput!) {
    createTeam(createTeamInput: $createTeamInput) {
      id
      name
      description
      color
      isActive
      isContractor
      department
      createdAt
      updatedAt
      memberCount
      memberIds
    }
  }
`;

// Update team mutation
export const UPDATE_TEAM = gql`
  mutation UpdateTeam($updateTeamInput: UpdateTeamInput!) {
    updateTeam(updateTeamInput: $updateTeamInput) {
      id
      name
      description
      color
      isActive
      isContractor
      department
      createdAt
      updatedAt
      memberCount
      memberIds
    }
  }
`;

// Delete team mutation
export const DELETE_TEAM = gql`
  mutation DeleteTeam($id: Int!) {
    removeTeam(id: $id)
  }
`;

// Deactivate team mutation
export const DEACTIVATE_TEAM = gql`
  mutation DeactivateTeam($id: Int!) {
    deactivateTeam(id: $id) {
      id
      name
      description
      color
      isActive
      isContractor
      department
      createdAt
      updatedAt
      memberCount
      memberIds
    }
  }
`;

// Activate team mutation
export const ACTIVATE_TEAM = gql`
  mutation ActivateTeam($id: Int!) {
    activateTeam(id: $id) {
      id
      name
      description
      color
      isActive
      isContractor
      department
      createdAt
      updatedAt
      memberCount
      memberIds
    }
  }
`;

// Update user team assignment (legacy single-team)
export const UPDATE_USER_TEAM = gql`
  mutation UpdateUserTeam($userId: Int!, $teamId: Int) {
    updateUserTeam(userId: $userId, teamId: $teamId) {
      id
      firstName
      lastName
      email
      teamId
      team {
        id
        name
        color
      }
    }
  }
`;

// New multi-team mutations
export const ADD_USER_TO_TEAM = gql`
  mutation AddUserToTeam($userId: Int!, $teamId: Int!, $isPrimary: Boolean) {
    addUserToTeam(userId: $userId, teamId: $teamId, isPrimary: $isPrimary) {
      id
      userId
      teamId
      isPrimary
      createdAt
      user {
        id
        firstName
        lastName
        email
        role
        isActive
      }
      team {
        id
        name
        color
      }
    }
  }
`;

export const REMOVE_USER_FROM_TEAM = gql`
  mutation RemoveUserFromTeam($userId: Int!, $teamId: Int!) {
    removeUserFromTeam(userId: $userId, teamId: $teamId)
  }
`;

export const SET_USER_PRIMARY_TEAM = gql`
  mutation SetUserPrimaryTeam($userId: Int!, $teamId: Int!) {
    setUserPrimaryTeam(userId: $userId, teamId: $teamId) {
      id
      userId
      teamId
      isPrimary
      createdAt
      user {
        id
        firstName
        lastName
        email
        role
        isActive
      }
      team {
        id
        name
        color
      }
    }
  }
`; 